import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="garantia" data-id="element-77" data-mp="1o46konudlsx5">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-78" data-mp="223y4543nw1ij">
        <div className="grid gap-8 rounded-2xl border-2 border-leaf bg-white p-7 sm:p-10 lg:grid-cols-[auto_1fr] lg:gap-12" data-id="element-79" data-mp="221bwl4grtm0b">
          <ShieldCheckIcon className="h-14 w-14 text-leaf-dark" aria-hidden="true" data-id="element-80" data-mp="19ehgejqzl8sn" />
          <div data-id="element-81" data-mp="14gfmf3s0vp2e">
            <h2 id="garantia" className="font-display text-2xl font-extrabold text-ink sm:text-3xl" data-id="element-82" data-mp="14gz4qlll4fgy">
              Garantía 7 días — sin preguntas
            </h2>
            <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-ink/75" data-id="element-83" data-mp="1ed27nto9gi4y">
              Abrís los tomos. Los usás en tu vida real. Si en 7 días no es lo
              que esperabas: devolución del 100%. Sin formularios. Sin drama.
            </p>
            <p className="mt-4 text-[15px] text-ink/70" data-id="element-84" data-mp="ozro0as4edzt">
              Escribís a{' '}
              <a href="mailto:soporteatajodigital@gmail.com" className="font-semibold text-leaf-dark underline decoration-leaf/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-ink" data-id="element-85" data-mp="tymiwb3d3t0a">
                soporteatajodigital@gmail.com
              </a>{' '}
              con tu comprobante y listo.
            </p>
            <p className="mt-6 border-t border-ink/10 pt-5 font-display text-lg font-bold text-ink" data-id="element-86" data-mp="62qjss6e4hwx">
              Tasa de devoluciones: menos del 1%.
              <span className="mt-1 block text-[15px] font-medium text-ink/60" data-id="element-87" data-mp="f12fv9q107wr">
                Porque cuando las personas ven el sistema, no lo devuelven. Lo
                usan.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}